let baseUrl = "";    //接口使用地址
let imageUrl = "";   //图片展示使用地址
let uploadPage = ""; //手机上传图片所打开的网站地址
let inspectionUrl = ""; // 检务系统地址
let ejianUrl = ""; // ejian地址
let ejianFrontUrl  = ""; //ejian前端地址
/**
 * 外部静态资源站点,用于异步加载opencv.js,xlsx.full.min.js,无法直接在项目引用.
 */
switch (process.env.VUE_APP_TITLE) {
    case 'dev':   // 注意这里的名字要和步骤二中设置的环境名字对应起来
        baseUrl = "http://192.168.31.152:8082"
        imageUrl = "http://192.168.31.152";
        uploadPage = "http://jlyw1.xk100.xyz/public";
        inspectionUrl = "http://detect1.xk100.xyz";
        ejianUrl = "http://detect1.ejian.xyz/api";
        ejianFrontUrl = "http://detect1.ejian.xyz";
        break
    case 'releasetest':
        baseUrl = "http://jlyw.hebjlzy.com/bgapi"
        imageUrl = "http://jlyw.hebjlzy.com";
        uploadPage = "http://jlyw.hebjlzy.com/public";
        inspectionUrl = "http://jlyw.hebjlzy.com";
        ejianUrl = "http://im.hebjlzy.com/api";
        ejianFrontUrl = "http://im.hebjlzy.com";
        break
    case 'prodtest':
        baseUrl = "http://jlyw1.xk100.xyz/bgapi"
        imageUrl = "http://jlyw1.xk100.xyz";
        uploadPage = "http://jlyw1.xk100.xyz/public";
        inspectionUrl = "http://detect1.xk100.xyz";
        ejianUrl = "http://detect1.ejian.xyz/api";
        ejianFrontUrl = "http://detect1.ejian.xyz";
        break
    case 'canary':
        {
            baseUrl = "http://edu.iseoo.com.cn:21090"
            imageUrl = "http://edu.iseoo.com.cn:21091";
            uploadPage = "http://edu.iseoo.com.cn:21091";
            inspectionUrl = "http://192.168.178.32:5173";
            ejianUrl = "http://detect.ejian.xyz/api";
            ejianFrontUrl = "http://detect.ejian.xyz";
        }
        break;

    case 'release':
        {
            baseUrl = "/bgapi"
            imageUrl = "";
            uploadPage = "";
            inspectionUrl = "http://jljd.hebjlzy.com";
            ejianUrl = "http://im.hebjlzy.com/api";
            ejianFrontUrl = "http://im.hebjlzy.com";
        }
        break;
}
export default baseUrl;
export { baseUrl, imageUrl, uploadPage, inspectionUrl, ejianUrl,ejianFrontUrl };
